import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams, Link } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";

let apiServices = new ApiService();



const ThankYou = () => {

  let history = useHistory();
  const didMountRef = useRef(true);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [txndata, settxndata] = useState([]);
  const [txndetaildata, settxndetaildata] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    if (didMountRef.current) {
      gettransactiondata();
    }
    didMountRef.current = false;
  });
  const gettransactiondata = () => {
    setSpinnerLoading(true);
    const dataString = {
      "txnorderno": atob(id),
    }
    apiServices.gettransactiondata(dataString).then(res => {
      if (res.data.status == 'success') {
        settxndata(res.data.txndata);
        settxndetaildata(res.data.txndetaildata);
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
      }
    })
  }
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      <section className='bg-gray-light section-small'>
        <div className="container">
          <div className='row justify-content-md-center'>
            <div className='col-lg-12'>
              <div className='tx-center'>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='mfsipbox mg-b-15'>
                <div className='mfsipbox-planname'>ThankYou - Order Details</div>
                <div className='mfshipboxform'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <div className='mfshipboxform-group'>
                        Transaction Id : {txndata.trans_order_no}
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='mfshipboxform-group'>
                        Transaction Type : {txndata.trans_type}
                      </div>
                    </div>
                    <div className='col-lg-12'>
                      <div className='mfshipboxform-group'>
                        Transaction Order Amount : ₹{txndata.trans_amount}
                      </div>
                    </div>
                  </div></div>
              </div>
              {txndetaildata.length > 0
                ? txndetaildata.map((key) => (
                  <div className='mfsipbox mg-b-15'>
                    <div className='mfsipbox-planname'>{key.txn_mf_name}</div>
                    <div className='mfshipboxform'>
                      <div className='row'>

                        <div className='col-lg-6'>
                          <div className='mfshipboxform-group'>
                            Transaction Id : {key.txn_order_id}
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className='mfshipboxform-group'>
                            Scheme Code : {key.txn_mf_schemecode}
                          </div>
                        </div>
                        {
                          txndata.trans_type == 'PUR' ?
                            <div className='col-lg-6'>
                              <div className='mfshipboxform-group'>
                                Purchase Amount : ₹{key.txn_amount}
                              </div>
                            </div>
                            :
                            <>
                              <div className='col-lg-6'>
                                <div className='mfshipboxform-group'>
                                  SIP Amount : ₹{key.txn_amount}
                                </div>
                              </div>
                              <div className='col-lg-6'>
                                <div className='mfshipboxform-group'>
                                  SIP Start On : {key.txn_sip_startday}/{key.txn_sip_startmonth}/{key.txn_sip_startyear}
                                </div>
                              </div>
                              <div className='col-lg-6'>
                                <div className='mfshipboxform-group'>
                                  SIP Ends In : {key.txn_sip_endmonth}/{key.txn_sip_endyear}
                                </div>
                              </div>
                            </>
                        }
                      </div>
                    </div>
                  </div>
                ))
                : ""}
              <div className="theme-button mg-t-20"><Link to='/dashboard' class="btn button02">Go To Dashboard</Link></div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default ThankYou;